<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left py-3">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Tarifas</h2>
          <p class="text-purple-manax pl-3 subtitle-section">Productos o Servicios que se incluirán en tus Presupuestos y Facturas.
          </p>
        </span>
        <span class="pull-right py-3 pr-3">
          <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openNewProductModal()">
            <i class="material-icons">add</i> Nuevo Producto o Servicio
          </button>
          <button mat-raised-button type="button" class="btn btn-outline-manax p-2" (click)="export()">
            <i class="material-icons">download</i> Exportar
          </button>
        </span>
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortProducts($event)" stickyHeader
          stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- All -->
              <!-- <th class="p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th> -->

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top" mat-sort-header="name"
                style="height: 70px; position: relative;">
                Nombre<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.name" (ngModelChange)="lazySearch()"
                  (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 35px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" mat-sort-header="name"
                style="height: 70px; position: relative;">
                Descripción<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.description"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 35px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" mat-sort-header="category"
                style="height: 70px; position: relative;">
                Categoría<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.category"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 35px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" mat-sort-header="price">
                Unidad
              </th>
              <th class="d-none d-md-table-cell align-top" mat-sort-header="cost">
                Costo {{curr}}
              </th>
              <th class="d-none d-md-table-cell align-top" mat-sort-header="price">
                Precio {{curr}}
              </th>
              <th class="d-none d-md-table-cell align-top" width="1%"
                style="height: 65px; position: relative; max-width: 1000px;" mat-sort-header="isDeleted">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.isDeleted" (ngModelChange)="getProducts(true)"
                  (click)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 35px; left: 0px;">
                  <option [ngValue]="false"> activo </option> <!-- isDeleted: false -->
                  <option [ngValue]="true"> inactivo </option> <!-- isDeleted: true -->
                  <option [ngValue]="undefined"> todos </option>
                </select>
              </th>

              <!-- Mobile -->
              <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort || ''] || 'ninguno'}}</span>
                <span class="text-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>

                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortProducts(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortProducts('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let product of products" [class.text-danger]="product.isDeleted" class='cursor-pointer'
              (click)="openProductModal(product, true)">

              <!-- All -->
              <!-- <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(product._id)"
                      [checked]="selection.all || selection[product._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td> -->

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{product.name}}</td>
              <td class="d-none d-md-table-cell">{{product.description}}</td>
              <td class="d-none d-md-table-cell">{{product.category?.name}}</td>
              <td class="d-none d-md-table-cell">{{product.unit}}</td>
              <td class="d-none d-md-table-cell">{{product.cost}}</td>
              <td class="d-none d-md-table-cell">{{product.price}}</td>
              <td class="d-none d-md-table-cell">
                <span *ngIf="!product.isDeleted">activa</span>
                <span *ngIf="product.isDeleted">borrada</span>
              </td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <b>{{product.name}}</b><br>
                <b>{{product.description}}</b><br>
                <span style="line-height: 15px;" class="small">
                  {{curr}} {{product.cost}}<br>
                  {{curr}} {{product.price}}<br>
                  Categoría: {{product.category?.name}}
                  Unidad: {{product.unit}}
                  <span class="pull-right" *ngIf="product.isDeleted">borrada</span>
                </span>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openProductModal(product, true)">
                    <span>Abrir</span>
                  </button>
                  <button mat-menu-item (click)="openProductModal(product)">
                    <span>Modificar</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteProductConfirm(product, true)" *ngIf="isDev">
                    <span>Hard Delete</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteProductConfirm(product)" *ngIf="!product.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreProductConfirm(product)" *ngIf="product.isDeleted">
                    <span>Restaurar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ products.length }} productos</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>